// Single source of truth for "which payment processor does THIS org charge on?"
// Used to make money-UI labels processor-aware (Stripe vs Ziina) everywhere.
import { useEffect, useState } from 'react';
import apiV2 from './apiV2';

const DEFAULT = { provider: 'stripe', name: 'Stripe', isZiina: false, ziinaConnected: false, accountStatus: null };

let _cache = null;
let _promise = null;

export const fetchPaymentProcessor = () => {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    const orgId = localStorage.getItem('organizationId');
    if (!orgId) return Promise.resolve(DEFAULT);
    _promise = apiV2
      .get(`/organizations/${orgId}/ziina/status`)
      .then((r) => {
        const d = r.data || {};
        const isZiina = d.provider === 'ziina' && !!d.connected;
        _cache = {
          provider: isZiina ? 'ziina' : 'stripe',
          name: isZiina ? 'Ziina' : 'Stripe',
          isZiina,
          ziinaConnected: !!d.connected,
          accountStatus: d.accountStatus || null,
        };
        return _cache;
      })
      .catch(() => {
        _cache = DEFAULT;
        return _cache;
      });
  }
  return _promise;
};

export const clearPaymentProcessorCache = () => {
  _cache = null;
  _promise = null;
};

export const usePaymentProcessor = () => {
  const [proc, setProc] = useState(_cache || DEFAULT);
  useEffect(() => {
    let live = true;
    fetchPaymentProcessor().then((p) => { if (live) setProc(p); });
    return () => { live = false; };
  }, []);
  return proc;
};
